import { render } from "./FormEditor.vue?vue&type=template&id=50442d7e&scoped=true&ts=true"
import script from "./FormEditor.vue?vue&type=script&lang=ts"
export * from "./FormEditor.vue?vue&type=script&lang=ts"

import "./FormEditor.vue?vue&type=style&index=0&id=50442d7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50442d7e"]])

export default __exports__